/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_ConfirmedInputs */

const en_so_status_confirmed = /** @type {(inputs: So_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To allocate`)
};

/**
* | output |
* | --- |
* | "To allocate" |
*
* @param {So_Status_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_confirmed = /** @type {((inputs?: So_Status_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_confirmed(inputs)
});